/* eslint-disable */
import React, { useState, useEffect, useRef, useCallback } from "react";
import fieldPropTypes from "./field-prop-types";
import GraphWrapper from "../theme/default/graph-wrapper";

const Graph = ({ field: { data } }) => {
  const { graph } = data;

  const breakpoints = [
    {
      breakpointMin: 150,
      breakpointMax: 320,
      height: 350
    },
    {
      breakpointMin: 320,
      breakpointMax: 375,
      height: 350
    },
    {
      breakpointMin: 375,
      breakpointMax: 576,
      height: 350
    },
    {
      breakpointMin: 576,
      breakpointMax: 768,
      height: 400
    },
    {
      breakpointMin: 768,
      breakpointMax: 992,
      height: 700
    },
    {
      breakpointMin: 992,
      breakPointMax: 1200,
      height: 800
    },
    {
      breakpointMin: 1150,
      breakPointMax: 2000,
      height: 900
    }
  ];

  const graphWrapperRef = useRef(null);
  const maxBedMinutes = 600;

  const [graphColumnDimension, setGraphColumnDimension] = useState({
    width: 34,
    height: 280
  });
  const [graphVerticalSteps, setGraphVerticalSteps] = useState(0);

  useEffect(() => {
    calculateGraphColumnDimension(graphWrapperRef.current.offsetWidth - 40);
  }, []);

  useEffect(() => {
    calculateVerticalGraphTimes();
  }, [graphColumnDimension]);

  const debounceResizeHanedler = useCallback(() => {
    if (graphWrapperRef.current) {
      const timeout = setTimeout(() => {
        calculateGraphColumnDimension(graphWrapperRef.current.offsetWidth - 40);
        clearTimeout(timeout);
      }, 500);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", debounceResizeHanedler);
    return () => {
      window.removeEventListener("resize", debounceResizeHanedler);
    };
  }, [debounceResizeHanedler]);

  const calculateGraphColumnDimension = useCallback(wrapperWidth => {
    const numberOfColumns = 7;
    const calculatedWidth = wrapperWidth / numberOfColumns;
    let calculatedHeight = 0;

    for (let i = 0; i < breakpoints.length; i++) {
      if (
        wrapperWidth > breakpoints[i].breakpointMin &&
        breakpoints[i].breakpointMax > wrapperWidth
      ) {
        calculatedHeight = breakpoints[i].height;
      }
    }

    setGraphColumnDimension({
      width: calculatedWidth,
      height: calculatedHeight
    });
  });

  const calculateVerticalGraphTimes = useCallback(() => {
    const numOfSteps = 5;
    const verticalStepHeight = 20;
    const calculatedStepDimension =
      (graphColumnDimension.height - verticalStepHeight * numOfSteps) /
      numOfSteps;
    setGraphVerticalSteps(calculatedStepDimension);
  });

  const calculateBarHeight = useCallback(bedMin => {
    let height = graphColumnDimension.height;
    if (bedMin < maxBedMinutes) {
      // "6.52"
      // "1.50"

      //const percent = ((bedMin * bedMin) / maxBedMinutes)
      const percent = (bedMin / maxBedMinutes) * 100;
      console.log("percent: ", percent);
      height = (percent * graphColumnDimension.height) / 100;
    }
    // console.log('column height: ', graphColumnDimension.height)
    // console.log('neki bedMin: ', bedMin)
    // console.log('maxBedminutes: ', maxBedMinutes)
    // console.log('height: ', height)
    return height;
  });

  return (
    <GraphWrapper
      graphRef={graphWrapperRef}
      showGrid={graph?.show_grid}
      showColumnName={graph?.show_column_name}
      timeLabels={graph?.label?.values}
      verticalSteps={graphVerticalSteps}
      graphColumns={graph?.columns}
      graphColumnWidth={graphColumnDimension?.width}
      graphColumnHeight={graphColumnDimension?.height}
      calculateBarHeight={calculateBarHeight}
    />
  );
};

Graph.propTypes = fieldPropTypes;
export default Graph;
